import { List, SimpleList } from 'react-admin'

export const QAList = (props: any) => (
  <List {...props}>
    <SimpleList
      primaryText={(record) => record.name}
      secondaryText={(record) => record.description}
      linkType={'edit'}
    />
  </List>
)

export default QAList
